<template>
    <div v-show="loading">
        <div class="fullview">
            <vue-loading type="spiningDubbles"
                         color="#aaa"
                         :size="{ width: '100px', height: '100px' }" />
        </div>
    </div>
</template>

<script>
    import { VueLoading } from "vue-loading-template";
    import Vue from "vue"
    export default Vue.extend({
        name: "Loading",
        props: {
            loading: Boolean
        },
        components: {
            VueLoading
        }
    });
</script>

<style lang="scss">
    .fullview {
        width: 100%;
        height: 100%;
        background: rgba(128, 128, 128, 0);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10001; // modal-fullの9999とかにまける

        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>